var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4V20C0 21.0609 0.421427 22.0783 1.17157 22.8284C1.92172 23.5786 2.93913 24 4 24H20C20.3536 24 20.6928 23.8595 20.9428 23.6095C21.1929 23.3594 21.3333 23.0203 21.3333 22.6667V1.33333C21.3333 0.979711 21.1929 0.640573 20.9428 0.390524C20.6928 0.140476 20.3536 0 20 0ZM4 2.66667H18.6667V16H4C3.54514 16.0036 3.09423 16.0848 2.66667 16.24V4C2.66667 3.64638 2.80714 3.30724 3.05719 3.05719C3.30724 2.80714 3.64638 2.66667 4 2.66667ZM4 21.3333C3.64638 21.3333 3.30724 21.1929 3.05719 20.9428C2.80714 20.6928 2.66667 20.3536 2.66667 20C2.66667 19.6464 2.80714 19.3072 3.05719 19.0572C3.30724 18.8071 3.64638 18.6667 4 18.6667H18.6667V21.3333H4Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditional);
export default __webpack_public_path__ + "static/media/additional.756c60cd6ace2ef5b45df184380df34e.svg";
export { ForwardRef as ReactComponent };